// extracted by mini-css-extract-plugin
export default {"container":"DIDMyNumbers_container__XziK2","mobileHeader":"DIDMyNumbers_mobileHeader__V+aS5","text":"DIDMyNumbers_text__1pfbJ"};